import { Controller } from "@hotwired/stimulus";

// The canonical board's audience picker, inside the Publish dialog: the tenant list is only
// meaningful under the "selected" scope, so it follows the radio.
//
// Hidden rather than removed, and its checkboxes stay ENABLED: the selection is submitted either way,
// so an author who flips to "All eligible tenants" and back finds the set they built still there. The
// server ignores tenant_ids unless the scope is "selected", which is what makes that safe.
export default class extends Controller {
  static targets = ["tenantList"];

  scopeChanged(event) {
    if (!this.hasTenantListTarget) return;

    this.tenantListTarget.classList.toggle("hidden", event.target.value !== "selected");
  }

  // Cancel abandons the edits rather than parking them: the dialog only toggles visibility, so without
  // this a cancelled selection is still there on reopen and the next Save publishes it.
  //
  // The multiselect keeps its selection in a Stimulus value rather than in the inputs, so form.reset()
  // alone would restore the radios and leave the tenant chips as the author left them. Reading the
  // value back off the server-rendered attribute is what actually undoes it.
  reset() {
    this.element.reset();
    this.element.querySelectorAll("[data-controller~='multiselect']").forEach((root) => {
      const multiselect = this.application.getControllerForElementAndIdentifier(root, "multiselect");
      if (!multiselect) return;

      multiselect.selectedValue = JSON.parse(root.dataset.multiselectSelectedValue || "[]");
      multiselect.updateCheckmarks();
      multiselect.updateDisplay();
      multiselect.updateHiddenInputs();
    });
    const scope = this.element.querySelector("input[name='all_tenants']:checked");
    if (scope && this.hasTenantListTarget) {
      this.tenantListTarget.classList.toggle("hidden", scope.value !== "selected");
    }
  }
}
